export default "__VITE_ASSET__DJzALMsR__"